import { alpha } from '@mui/material';
import { clamp } from '@ui/style/clamp-calculator';
const useHomeEventsFrameStyles = () => {
    return {
        eventFrame: {
            display: 'flex',
            flexDirection: 'column',
            borderRadius: 3,
            gap: 1,
            border: (theme) => `1px solid ${alpha(theme.palette.grey[500], 0.32)}`,
            px: (theme) => theme.spacing(2.5),
            py: (theme) => theme.spacing(2),
            // boxShadow: '0px 12px 24px -4px #919EAB1F, 0px 0px 2px 0px #919EAB33',
            //backgroundColor: (theme) => alpha(theme.palette.grey[500], 0.08),
            width: '100%'
        },
        eventPreviewImage: {
            aspectRatio: 1,
            width: clamp.calculate(45, 87),
            height: clamp.calculate(45, 72),
            borderRadius: 1,
        },
        profileImage: {
            aspectRatio: 1,
            width: clamp.calculate(32, 32),
            height: clamp.calculate(32, 32),
            borderRadius: 1.5,
            backgroundColor: (theme) => theme.palette.grey[300]
        },
        thumbnail: {
            // ...centered,
            position: 'relative'
        },
        contentContainer: {
            display: 'flex',
            flex: 1,
            minWidth: 0,
            justifyContent: 'space-between',
            flexDirection: 'column'
        }
    };
};
export default useHomeEventsFrameStyles;
